import { c as _c } from "react/compiler-runtime";
export default function DistributionPlanToolNotConnected() {
  const $ = _c(3);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <h1 className="tw-text-white">EMMA</h1>;
    t1 = <h2 className="tw-text-white">Connect Your Wallet</h2>;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="tw-flex tw-flex-col">{t0}{t1}<div className="tw-mb-6 lg:tw-max-w-2xl"><p className="tw-text-justify tw-mb-0 tw-mt-2 tw-text-base tw-leading-[1.6] tw-font-normal tw-text-iron-300">Connect with an address from within your consolidated account to proceed, so that we can verify your TDH to grant you access. No special delegation is required. Please don't connect your vault.</p><p className="tw-text-justify tw-mb-0 tw-mt-2 tw-text-base tw-leading-[1.6] tw-font-normal tw-text-iron-300">No gas is needed to sign in, and there is no cost or fee to use the tool.</p></div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}